import api from '@/services/api';

export async function listFeedbackSubjects() {
  const { data } = await api.get('/feedback-subjects');
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data)) return data;
  return [];
}
